module.exports = __webpack_public_path__ + "media/images/weather/158_night-3b17110586191ab23301ea94cc572fa8.png";